import { gql, TypedDocumentNode } from '@common/hooks';
import {
  HistoryInfoFragment,
  ExtensionOfferPreviewQueryQueryCgResponse,
  ExtensionOfferPreviewQueryQueryVariables,
} from '@common/graphql';

export type ExtensionOfferPreviewType =
  ExtensionOfferPreviewQueryQueryCgResponse['extensionOffer'];

export const EXTENSION_OFFER_PREVIEW_QUERY: TypedDocumentNode<
  ExtensionOfferPreviewQueryQueryCgResponse,
  ExtensionOfferPreviewQueryQueryVariables
> = gql`
  query ExtensionOfferPreviewQuery($id: ID!) {
    extensionOffer(id: $id) {
      id
      state
      stateChangedAt
      rejectionReason
      rejectionDetails
      startDate
      endDate
      billingRegularRate
      shiftType
      shiftsPerWeek
      hoursPerShift
      overtimeThreshold
      timeoffDescription
      extensionReason
      history {
        ...HistoryInfoFragment
      }
      offerChangeRequests {
        id
        createdAt
        updatedAt
        note
        worksMembership {
          id
          name
        }
        canCreateResponse {
          value
        }
        offerChangeResponse {
          id
          updatedAt
          note
          worksMembership {
            id
            name
          }
          detail {
            ... on OfferAcceptanceResponseDetail {
              id
              oldBillingRegularRate
              oldStartDate
              oldEndDate
              oldShiftType
              oldShiftsPerWeek
              oldHoursPerShift
              oldTimeoffDescription
            }
            ... on ExtensionOfferAcceptanceResponseDetail {
              id
              oldEndDate
              oldShiftType
              oldShiftsPerWeek
              oldHoursPerShift
              oldTimeoffDescription
            }
          }
        }
      }

      staffingRequestAssignment {
        id
        staffingRequestApplication {
          id
          worksProfile {
            id
            fullName
          }
          organization {
            id
            name
          }
          staffingRequest {
            id
            code
            staffingRequestType
            role {
              id
              abbreviation
            }
            organizationUnit {
              id
              department {
                id
                name
                organizationBusiness {
                  id
                  name
                  city
                  stateCode
                }
              }
            }
          }
        }
      }
    }
  }
  ${HistoryInfoFragment}
`;
